module.exports = __webpack_public_path__ + "static/media/Curoflow telemedicine plattform in United Arab Emirates.bd0e9bfa.webp";